import { render, staticRenderFns } from "./bot-update-logs.vue?vue&type=template&id=11b5a618&scoped=true&"
import script from "./bot-update-logs.vue?vue&type=script&lang=js&"
export * from "./bot-update-logs.vue?vue&type=script&lang=js&"
import style0 from "./bot-update-logs.vue?vue&type=style&index=0&id=11b5a618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b5a618",
  null
  
)

export default component.exports